/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StateDto } from './StateDto';
import {
    StateDtoFromJSON,
    StateDtoFromJSONTyped,
    StateDtoToJSON,
    StateDtoToJSONTyped,
} from './StateDto';

/**
 * 
 * @export
 * @interface StatesResponseDto
 */
export interface StatesResponseDto {
    /**
     * List of states
     * @type {Array<StateDto>}
     * @memberof StatesResponseDto
     */
    data: Array<StateDto>;
    /**
     * Total number of states
     * @type {number}
     * @memberof StatesResponseDto
     */
    total: number;
    /**
     * Country code
     * @type {string}
     * @memberof StatesResponseDto
     */
    countryCode: string;
}

/**
 * Check if a given object implements the StatesResponseDto interface.
 */
export function instanceOfStatesResponseDto(value: object): value is StatesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function StatesResponseDtoFromJSON(json: any): StatesResponseDto {
    return StatesResponseDtoFromJSONTyped(json, false);
}

export function StatesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(StateDtoFromJSON)),
        'total': json['total'],
        'countryCode': json['countryCode'],
    };
}

export function StatesResponseDtoToJSON(json: any): StatesResponseDto {
    return StatesResponseDtoToJSONTyped(json, false);
}

export function StatesResponseDtoToJSONTyped(value?: StatesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(StateDtoToJSON)),
        'total': value['total'],
        'countryCode': value['countryCode'],
    };
}

